<template>
	<div class="idcard-uploader">
		<div class="uploader-title" v-if="title">
			{{ title }}
		</div>
		<div class="uploader-content">
			<div class="uploader-item">
				<div class="cropper-box">
					<img :src="frontImage || defaultFront" class="preview-img"/>
					<h5-cropper 
						v-show="!frontImage"
						:option="cropOptions"
						@getbase64="handleFrontCrop"
					></h5-cropper>
					<div v-if="!frontImage" class="upload-tip">
						<van-icon name="photograph" size="24" color="#999"/>
						<span>点击上传</span>
					</div>
					<van-icon v-if="frontImage" name="clear" class="clear-icon" @click.stop="clearFront"/>
				</div>
				<div class="item-label">身份证正面</div>
			</div>
			<div class="uploader-item">
				<div class="cropper-box">
					<img :src="backImage || defaultBack" class="preview-img"/>
					<h5-cropper 
						v-show="!backImage"
						:option="cropOptions"
						@getbase64="handleBackCrop"
					></h5-cropper>
					<div v-if="!backImage" class="upload-tip">
						<van-icon name="photograph" size="24" color="#999"/>
						<span>点击上传</span>
					</div>
					<van-icon v-if="backImage" name="clear" class="clear-icon" @click.stop="clearBack"/>
				</div>
				<div class="item-label">身份证反面</div>
			</div>
		</div>
	</div>
</template>

<script>
import H5Cropper from 'vue-cropper-h5'

export default {
	name: 'IdcardUploader',
	components: {
		H5Cropper
	},
	props: {
		title: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			defaultFront: require('@/assets/idcard/idcard_f.png'),
			defaultBack: require('@/assets/idcard/idcard_b.png'),
			frontImage: '',
			backImage: '',
			cropOptions: {
				fixedNumber: [1.6, 1],
				fixedBox: false,
				canMoveBox: true,
				outputType: 'jpeg',
				outputSize: 0.8
			}
		}
	},
	computed: {
		isComplete() {
			return !!this.frontImage && !!this.backImage
		}
	},
	methods: {
		handleFrontCrop(data) {
			this.frontImage = data
			this.emitChange()
		},
		handleBackCrop(data) {
			this.backImage = data
			this.emitChange()
		},
		clearFront() {
			this.frontImage = ''
			this.emitChange()
		},
		clearBack() {
			this.backImage = ''
			this.emitChange()
		},
		emitChange() {
			this.$emit('change', {
				front: this.frontImage,
				back: this.backImage,
				isComplete: this.isComplete
			})
			if (this.isComplete) {
				this.$emit('complete', {
					front: this.frontImage,
					back: this.backImage
				})
			}
		},
		reset() {
			this.frontImage = ''
			this.backImage = ''
			this.emitChange()
		},
		getData() {
			return {
				front: this.frontImage,
				back: this.backImage,
				isComplete: this.isComplete
			}
		}
	}
}
</script>

<style lang="less" scoped>
.idcard-uploader {
	padding: 10px 0;
	
	.uploader-title {
		text-align: center;
		font-size: 14px;
		color: #666;
		margin-bottom: 15px;
	}
	
	.uploader-content {
		display: flex;
		justify-content: space-around;
		padding: 0 16px;
		
		.uploader-item {
			width: 45%;
			text-align: center;
			
			.cropper-box {
				width: 100%;
				height: 130px;
				position: relative;
				border-radius: 8px;
				overflow: hidden;
				border: 1px dashed #ddd;
				background-color: #fafafa;
				
				.preview-img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					position: absolute;
					top: 0;
					left: 0;
				}
				
				.upload-tip {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					z-index: 1;
					pointer-events: none;
					
					span {
						font-size: 12px;
						color: #999;
						margin-top: 6px;
					}
				}
				
				.clear-icon {
					position: absolute;
					top: 5px;
					right: 5px;
					font-size: 18px;
					color: #fff;
					background: rgba(0,0,0,0.5);
					border-radius: 50%;
					padding: 3px;
					z-index: 10;
				}
				
				/deep/ .upbtn {
					width: 100%;
					height: 130px;
				}
			}
			
			.item-label {
				margin-top: 8px;
				font-size: 12px;
				color: #666;
			}
		}
	}
}
</style>
